import safeFetch from '../utils/safeFetch';

export async function get<T>(url: string | URL | undefined) {
  if (!url) {
    return;
  }

  return safeFetch(url, {
    method: 'GET',
  }).then((response) => {
    if (!response) {
      // TODO: add handling for undefined
      return;
    }
    response.json() as T;
  });
}
